import type { BillingPillVariant } from "@/features/billing/formatBillingStatus";
import {
  billingTextSeparator,
  getBillingPillDisplay,
} from "@/features/billing/formatBillingStatus";
import type { BillingStatus } from "@/types/api";

const VARIANT_CLASS: Record<BillingPillVariant, string> = {
  normal: "border-[var(--border)] bg-[var(--surface-2)]",
  low: "border-amber-200 bg-amber-50 text-amber-950",
  exhausted: "border-red-200 bg-red-50 text-red-950",
};

interface BillingStatusPillProps {
  status: BillingStatus;
}

/** Compact plan label for the top bar; quota details live on the Plans page. */
export function BillingStatusPill({ status }: BillingStatusPillProps) {
  const { planLabel, detail, variant, title } = getBillingPillDisplay(status);
  const pillVariant = status.subscribed ? "normal" : variant;
  const showTrialDays = Boolean(status.trial_active && !status.subscribed && detail);

  return (
    <span
      className={`balance-pill font-semibold ${VARIANT_CLASS[pillVariant]}`}
      title={title}
    >
      {planLabel}
      {showTrialDays ? (
        <>
          {" "}
          {billingTextSeparator}{" "}
          <span className="font-medium tabular-nums">{detail}</span>
        </>
      ) : null}
    </span>
  );
}
